import { useEffect, useState } from 'react'

type Options = {
  /** Minimalna odległość od góry, zanim pasek może się pokazać. */
  minScrollY?: number
  /** Ignoruj drobne ruchy scrolla (px). */
  threshold?: number
}

export function useScrollUpReveal({ minScrollY = 160, threshold = 10 }: Options = {}): boolean {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    let lastY = window.scrollY

    const onScroll = () => {
      const y = window.scrollY
      const delta = y - lastY

      if (Math.abs(delta) < threshold) return

      if (y < minScrollY) {
        setVisible(false)
      } else if (delta < 0) {
        setVisible(true)
      } else {
        setVisible(false)
      }

      lastY = y
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [minScrollY, threshold])

  return visible
}
